import { SET_PIPELINE } from '../../actionTypes';
import { debugAction } from '../../utils';

export const pipeline = {
  data: {
    resources: []
  }
};

export function pipelineReducer(state = pipeline, action) {
  debugAction(action);
  switch (action.type) {
    case SET_PIPELINE:
      return { data: action.payload };
    default:
      return { ...state };
  }
}
